import { render, staticRenderFns } from "./CreateStagingModal.vue?vue&type=template&id=03d2e40e&scoped=true"
import script from "./CreateStagingModal.vue?vue&type=script&lang=js"
export * from "./CreateStagingModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.scss?vue&type=style&index=0&id=03d2e40e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d2e40e",
  null
  
)

export default component.exports